import _suggestInfoCircleLine from "@zenlayer/zen-design-icons/assets/suggest/InfoCircleLine.svg";
import _suggestCloseCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg";
import _suggestClose from "@zenlayer/zen-design-icons/assets/suggest/Close.svg";
import _generalSearch from "@zenlayer/zen-design-icons/assets/general/Search.svg";
import { useMemoizedFn } from 'ahooks';
import classnames from 'classnames';
import React, { useRef } from 'react';
import Icon from '../icon';
import Modal from '../modal';
import Table from '../table';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SuperSearchDemo = _ref => {
  let {
    value,
    placeholder,
    baseClassName
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, 'focus-within'),
    style: {
      width: '100%',
      pointerEvents: 'none'
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--prefix"),
      children: /*#__PURE__*/_jsx(Icon, {
        type: "general/Search",
        block: true,
        className: "search-icon"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--content"),
      children: [value.map(v => /*#__PURE__*/_jsxs("div", {
        className: "demo-item",
        children: [/*#__PURE__*/_jsx("span", {
          className: "demo-item--text",
          children: v
        }), /*#__PURE__*/_jsx("span", {
          className: "demo-item--remove",
          children: /*#__PURE__*/_jsx(Icon, {
            type: "suggest/Close",
            block: true
          })
        })]
      }, v)), /*#__PURE__*/_jsx("div", {
        className: "demo-placeholder",
        children: placeholder
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--suffix"),
      children: [/*#__PURE__*/_jsx("span", {
        className: "action-icon",
        children: /*#__PURE__*/_jsx(Icon, {
          type: "suggest/CloseCircleFill",
          block: true
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "action-icon",
        children: /*#__PURE__*/_jsx(Icon, {
          type: "suggest/InfoCircleLine",
          block: true
        })
      })]
    })]
  });
};
const TipModalContent = _ref2 => {
  let {
    baseClassName,
    text
  } = _ref2;
  const props = useRef({
    columns: [{
      dataIndex: 'td1',
      title: text.modalTip.th.td1,
      width: 100,
      render(v) {
        return /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: v
          }
        });
      }
    }, {
      dataIndex: 'td2',
      title: text.modalTip.th.td2,
      width: 180,
      render(v) {
        return /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: v
          }
        });
      }
    }, {
      dataIndex: 'td3',
      title: text.modalTip.th.td3,
      width: 120,
      render(v) {
        return /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: v
          }
        });
      }
    }, {
      dataIndex: 'td4',
      title: text.modalTip.th.td4,
      width: 552,
      render(v, r, i) {
        const demoProps = [{
          value: ['IPv4: 192.168.1.86'],
          placeholder: text.placeholder.empty.focus.single
        }, {
          value: ['Instance ID: 750339712325259170'],
          placeholder: text.placeholder.empty.focus.single
        }, {
          value: ['Instance ID: 750339712325259170', 'Instance Name: S9F-MAD-A-02'],
          placeholder: text.placeholder.empty.focus.single
        }, {
          value: ['IPv4: 192.168.1.86 | 192.168.0.0'],
          placeholder: text.placeholder.empty.focus.multiple
        }, {
          value: ['IPv4: 192.168.1.86 | 192.168.0.0 | 192.168.0.23'],
          placeholder: text.placeholder.empty.focus.multiple
        }];
        if (demoProps[i]) {
          return /*#__PURE__*/_jsx(SuperSearchDemo, {
            baseClassName: baseClassName,
            ...demoProps[i]
          });
        }
        return null;
      }
    }, {
      dataIndex: 'td5',
      title: text.modalTip.th.td5,
      render(v) {
        return /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: v
          }
        });
      }
    }],
    dataSource: [text.modalTip.tr1, text.modalTip.tr2, text.modalTip.tr3, text.modalTip.tr4, text.modalTip.tr5]
  });
  return /*#__PURE__*/_jsx(Table, {
    rowKey: "td1",
    ...props.current
  });
};
export default function useTipModal() {
  const [modal] = Modal.useModal();
  const open = useMemoizedFn(options => {
    modal.open({
      width: 1200,
      closable: true,
      title: options.text.modalTip.title,
      content: /*#__PURE__*/_jsx(TipModalContent, {
        ...options
      }),
      okButtonText: null,
      cancelButtonText: null
    });
  });
  return {
    open
  };
}